import React, { useContext } from "react";
import { makeStyles } from "@material-ui/styles";
import { AppContext, DispatchContext } from "../AppContext";
import * as actions from "../actions/actions";
import { Select, InputLabel, FormControl, MenuItem } from "@material-ui/core";
import IconLabel from './IconLabel';
import PriceCard from './PriceCard';
import InvoiceAddressForm from './InvoiceAddressForm';


export default function CheckoutInvoiceAddressPanel() {

    const useStyles = makeStyles((theme) => ({
        root: {
            height: "100%",
            display: "grid",
            gridTemplateColumns: "16px 1fr 1fr 16px",
            gridTemplateRows: "120px 1fr",
            gridTemplateAreas: `
            "infoBar infoBar infoBar infoBar"
            "leftMargin productPanel addressPanel rightMargin"
            `,
            gap: "8px 20px",
        },
        leftMargin: { gridArea: "leftMargin" },
        rightMargin: { gridArea: "rightMargin" },
        infoBar: {
            gridArea: "infoBar",
            alignSelf: "center",
            justifySelf: "center"
        },
        productPanel: {
            marginTop: "40px",
            gridArea: "productPanel",
            alignSelf: "top",
            justifySelf: "center",
            textAlign: "center"
        },
        addressPanel: {
            gridArea: "addressPanel",
            alignSelf: "top",
            justifySelf: "left"
        },
        fullWidth: {
            width: "100%",
            marginBottom: theme.spacing(1)
        },
    }));

    const state = useContext(AppContext);
    const s = state.strings;
    const dispatch = useContext(DispatchContext);
    const classes = useStyles();
    const selectedProduct = state.checkout.productId ? state.checkout.products.filter(p => p.id == state.checkout.productId)[0] : null;

    const handleCheckoutChange = (newValue, key) => {
        dispatch(actions.setCheckoutDetails({ [key]: newValue }));
    };

    const setUser = (user) => {
        dispatch(actions.setUserDetails(user));
    };

    return (
        <div className={classes.root}>
            <div className={classes.leftMargin} />
            <div className={classes.rightMargin} />
            <div className={classes.infoBar}>
                <IconLabel label={s.paymentDialog.proviceInvoiceAddress} spacing={64} />
            </div>
            <div className={classes.productPanel}>
                {selectedProduct && selectedProduct.categoryId == 1 &&
                    <PriceCard title={selectedProduct.nameShort} text1={s.paymentDialog.priceCardCredits.format(selectedProduct.credits)} text2={s.paymentDialog.priceCardPages.format(selectedProduct.credits)}
                        text3={selectedProduct.users}
                        price={selectedProduct.cost[state.checkout.currency]}
                        currency={state.checkout.currency}
                        selected={true}
                        taxIncluded={state.checkout.taxIncluded}
                        vatRate={state.checkout.vatRate} />
                }
                {selectedProduct && selectedProduct.categoryId > 1 &&
                    <PriceCard title={selectedProduct.nameShort} text1={selectedProduct.credits + " ScanCredits " + (state.checkout.term == "monthly" ? s.paymentDialog.perMonth : s.paymentDialog.perYear)} text2={s.paymentDialog.unlimitedUsers}
                        text3={selectedProduct.users}
                        price={selectedProduct.cost[state.checkout.currency]}
                        currency={state.checkout.currency}
                        selected={true}
                        taxIncluded={state.checkout.taxIncluded}
                        vatRate={state.checkout.vatRate} />
                }
                <FormControl variant="outlined" style={{ marginTop: 20 }}>
                    <InputLabel>{s.paymentDialog.currency}</InputLabel>
                    <Select
                        onChange={(e) => handleCheckoutChange(e.target.value, 'currency')}
                        label={s.paymentDialog.currency}
                        value={state.checkout.currency}
                    >
                        <MenuItem value={"USD"}>USD</MenuItem>
                        <MenuItem value={"EUR"}>EUR</MenuItem>
                    </Select>
                </FormControl>
            </div>
            <div className={classes.addressPanel}>
                <InvoiceAddressForm user={state.user} setUser={setUser} />
            </div>
        </div>
    );
}